import { render, staticRenderFns } from "./AgentCommission.vue?vue&type=template&id=0ae6a6e2&scoped=true"
import script from "./AgentCommission.vue?vue&type=script&lang=js"
export * from "./AgentCommission.vue?vue&type=script&lang=js"
import style1 from "./AgentCommission.vue?vue&type=style&index=1&id=0ae6a6e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6a6e2",
  null
  
)

export default component.exports